/* ============================================================================
   Lagoon custom cart  ·  assets/lagoon-cart.js
   ----------------------------------------------------------------------------
   A custom side cart that replaces Rebuy's SmartCart (behind a theme toggle).
   Renders from /cart.js + the LIVE config (snippets/lagoon-cart-config.liquid):
     • line items with qty steppers + remove (Shopify /cart/change.js)
     • buy-more-save-more savings ladder (add 2nd pillow, add case,
       UPGRADE → swap to the real Peak Set SKU)
     • secondary "More Accessories" section (editable header)
     • discount-code box; NO stacking — Peak Set shows "best offer" message
     • free-shipping progress bar from the live threshold

   LIVE READS (nothing hardcoded):
     prices, titles, variant IDs, inventory  → /cart.js + config
     which offer is applied                  → cart.js discount applications
     discount eligibility (Our Pillows)      → config.discountable_product_ids
     Peak Set price + composition            → config.peak_set (live variants)
     free-ship threshold                     → config.free_shipping_threshold_cents

   DEV SEAMS are marked DEV. The cart-icon + add-to-cart hooks may need the
   theme's selectors; see INSTALL.md.
   ========================================================================== */
(function () {
  "use strict";

  var ROOT = document.getElementById("lagoon-cart");
  if (!ROOT) return;

  /* ---------- ACTIVATION GATE ----------
     Active when EITHER the theme launch flag is on (full rollout) OR a session
     QA flag is set. The QA flag is toggled by visiting any page with
     ?lagooncart=1 (persisted in sessionStorage for the whole session); turn it
     off with ?lagooncart=0. When NOT active we leave the page completely alone
     so Rebuy runs untouched for real shoppers. */
  try {
    var qp = new URLSearchParams(location.search);
    if (qp.has("lagooncart")) {
      var v = qp.get("lagooncart");
      if (v === "0" || v === "false") sessionStorage.removeItem("lgc_qa");
      else sessionStorage.setItem("lgc_qa", "1");
    }
  } catch (e) {}
  var LAUNCHED = ROOT.getAttribute("data-launch") === "true";
  var QA = false;
  try { QA = sessionStorage.getItem("lgc_qa") === "1"; } catch (e) {}
  var ACTIVE = LAUNCHED || QA;
  if (!ACTIVE) return;   // inert for everyone else → Rebuy unaffected

  /* ---------- suppress Rebuy SmartCart (only when WE are active) ----------
     Hide Rebuy's flyout and stop it auto-opening so the two carts don't fight.
     Scoped to this browser/session via the QA flag (or full launch). */
  function suppressRebuy() {
    document.documentElement.classList.add("lgc-rebuy-off");
    try {
      if (window.Rebuy && window.Rebuy.SmartCart) {
        if (typeof window.Rebuy.SmartCart.hide === "function") window.Rebuy.SmartCart.hide();
        if (typeof window.Rebuy.SmartCart.disable === "function") window.Rebuy.SmartCart.disable();
        window.Rebuy.SmartCart.autoOpen = false;
      }
    } catch (e) {}
  }
  // inject the hide-Rebuy CSS once
  (function () {
    var s = document.createElement("style");
    s.textContent = ".lgc-rebuy-off .rebuy-cart,.lgc-rebuy-off .rebuy-cart__flyout,.lgc-rebuy-off [data-rebuy-cart],.lgc-rebuy-off .rebuy-modal,.lgc-rebuy-off .rebuy-cart__overlay{display:none !important;visibility:hidden !important;pointer-events:none !important;}";
    document.head.appendChild(s);
  })();
  suppressRebuy();
  document.addEventListener("rebuy:cart.show", function (e) { try { e.preventDefault(); } catch (x) {} suppressRebuy(); }, true);
  setInterval(suppressRebuy, 1500);   // re-assert if Rebuy re-renders
  var MOUNT = ROOT.querySelector("[data-lgc-mount]");
  var CFG = {};
  try { CFG = JSON.parse(document.getElementById("lagoon-cart-config").textContent); } catch (e) { return; }

  var SHOW_DISCOUNT = ROOT.getAttribute("data-show-discount") !== "false";
  var SHOW_ACC = ROOT.getAttribute("data-show-accessories") !== "false";
  var ACC_HEADER = ROOT.getAttribute("data-accessories-header") || "More Accessories";
  var THRESH = CFG.free_shipping_threshold_cents || 0;
  var FOURPACK = CFG.fourpack_off_cents || 0;   // automatic 4+ pillow discount, $/pillow (cents)
  var DISCOUNTABLE = {};
  (CFG.discountable_product_ids || []).forEach(function (id) { DISCOUNTABLE[id] = true; });

  /* ---------- money ---------- */
  function money(cents) {
    var v = (cents / 100).toFixed(2);
    var fmt = CFG.money_format || "${{amount}}";
    return fmt.replace(/\{\{\s*amount\s*\}\}/, v).replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100));
  }

  /* ---------- AJAX cart ---------- */
  function getCart() { return fetch("/cart.js", { credentials: "same-origin" }).then(function (r) { return r.json(); }); }
  function changeLine(key, qty) {
    window.__lgcOp = Date.now();   // tell the PDP add-on to stand down (no companion re-add)
    return fetch("/cart/change.js", {
      method: "POST", headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify({ id: key, quantity: qty }),
    }).then(function (r) { return r.json(); });
  }
  function addItems(items) {
    window.__lgcOp = Date.now();   // tell the PDP add-on to stand down (no companion re-add)
    return fetch("/cart/add.js", {
      method: "POST", headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify({ items: items }),
    }).then(function (r) { return r.json(); });
  }

  /* ---------- offer detection (LIVE from cart) ----------
     cart.js reflects AUTOMATIC discounts in item final_price + line discount
     allocations. Code discounts (WELCOME20) apply at checkout; we still surface
     a "Discount code applied" state when one is stored on the cart. We read the
     applied title for display and rely on cart prices for truth. */
  function appliedDiscountTitle(cart) {
    // automatic + script discounts appear here
    var apps = cart.cart_level_discount_applications || [];
    if (apps.length) return apps[0].title || apps[0].code || "Discount";
    // line-level automatic allocations
    for (var i = 0; i < cart.items.length; i++) {
      var al = cart.items[i].line_level_discount_allocations || [];
      if (al.length) return (al[0].discount_application && (al[0].discount_application.title || al[0].discount_application.code)) || "Discount";
    }
    return null;
  }
  function appliedCode(cart) {
    var apps = cart.cart_level_discount_applications || [];
    if (apps.length) return apps[0].code || apps[0].title || null;
    for (var i = 0; i < cart.items.length; i++) {
      var al = cart.items[i].line_level_discount_allocations || [];
      if (al.length && al[0].discount_application) return al[0].discount_application.code || al[0].discount_application.title || null;
    }
    return null;
  }

  /* ---------- classify cart lines against the config ----------
     Match by variant ID, else by handle (with -recommend stripped), else by
     product title — so the hidden "-recommend" products (different variant IDs)
     still resolve to their canonical pillow/case. */
  function sameTitle(a, b) {
    a = (a || "").split("|")[0].trim().toLowerCase(); b = (b || "").split("|")[0].trim().toLowerCase();
    return a && b && a === b;
  }
  function findPillow(item) {
    if (typeof item === "number") return (CFG.pillows || []).find(function (p) { return p.variants.some(function (v) { return v.id === item; }); });
    var h = (item.handle || "").replace(/-recommend$/, "");
    return (CFG.pillows || []).find(function (p) {
      return p.variants.some(function (v) { return v.id === item.variant_id; }) || (h && h === p.handle) || sameTitle(item.product_title, p.title);
    });
  }
  function findCase(item) {
    if (typeof item === "number") return (CFG.cases || []).find(function (c) { return c.variants.some(function (v) { return v.id === item; }); });
    var h = (item.handle || "").replace(/-recommend$/, "");
    return (CFG.cases || []).find(function (c) {
      return c.variants.some(function (v) { return v.id === item.variant_id; }) || (h && h === c.handle) || sameTitle(item.product_title, c.title);
    });
  }
  function isPeak(item) {
    if (!CFG.peak_set) return false;
    if (typeof item === "number") return CFG.peak_set.variants.some(function (v) { return v.id === item; });
    var h = (item.handle || "").replace(/-recommend$/, "");
    return CFG.peak_set.variants.some(function (v) { return v.id === item.variant_id; }) || (h && h === CFG.peak_set.handle) || sameTitle(item.product_title, CFG.peak_set.title);
  }
  function variantSize(p, variantId) {
    var v = p.variants.find(function (x) { return x.id === variantId; });
    return v ? v.size : null;
  }

  /* ---------- the Peak Set variant for a given pillow+case+size ----------
     reads the live peak_set variants; matches by option strings. DEV: confirm
     the option encoding (pillow / case / size) matches your Peak Set product. */
  function peakVariantFor(pillowTitle, caseKind, size) {
    if (!CFG.peak_set || !CFG.peak_set.variants || !CFG.peak_set.variants.length) return null;
    var vs = CFG.peak_set.variants.filter(function (v) { return v.available !== false; });
    if (!vs.length) vs = CFG.peak_set.variants;
    var pillowShort = (pillowTitle || "").split("|")[0].replace(/^the\s+/i, "").trim().toLowerCase();
    var sz = (size || "").toLowerCase();
    function bySize(v) { var s = (v.size || "").toLowerCase(); return !sz || s === sz || s.indexOf(sz) !== -1; }
    // 1) pillow + size  2) size only  3) first available
    var hit = vs.find(function (v) { return (v.pillow || "").toLowerCase().indexOf(pillowShort) !== -1 && bySize(v); });
    if (!hit) hit = vs.find(bySize);
    if (!hit) hit = vs[0];
    return hit || null;
  }

  /* ---------- render ---------- */
  var STATE = { open: false };

  function lineDiscounted(item) {
    return item.original_line_price > item.final_line_price; // automatic discount present
  }

  function render(cart) {
    var offerTitle = appliedDiscountTitle(cart);
    var hasPeak = cart.items.some(function (it) { return isPeak(it); });

    // free shipping bar
    var pct = THRESH > 0 ? Math.min(100, Math.round(cart.total_price / THRESH * 100)) : 100;
    var remaining = Math.max(0, THRESH - cart.total_price);

    var html = "";
    html += '<div class="lgc-head"><h3>Your Cart (' + cart.item_count + ')</h3><button class="lgc-x" data-lgc-close aria-label="Close">\u2715</button></div>';

    html += '<div class="lgc-ship">';
    html += '<div class="lgc-ship-txt">' + (remaining > 0 ? "You\u2019re " + money(remaining) + " from free shipping" : "\uD83C\uDF89 Free shipping unlocked") + "</div>";
    html += '<div class="lgc-ship-bar"><div class="lgc-ship-fill" style="width:' + pct + '%"></div></div></div>';

    html += '<div class="lgc-scroll">';
    html += '<div class="lgc-items">';
    if (!cart.items.length) html += '<div class="lgc-empty">Your cart is empty.</div>';
    cart.items.forEach(function (it) {
      var disc = lineDiscounted(it);
      html += '<div class="lgc-item" data-key="' + it.key + '">';
      html += '<div class="lgc-img"><img src="' + (it.image || "") + '" alt=""></div>';
      html += '<div class="lgc-meta">';
      html += '<div class="lgc-name">' + it.product_title + "</div>";
      if (it.variant_title) html += '<div class="lgc-var">' + it.variant_title + "</div>";
      if (disc) html += '<span class="lgc-tag">' + (isPeak(it) ? "BUNDLE \u00B7 BEST VALUE" : (offerTitle || "SAVE")) + "</span>";
      html += '<div class="lgc-row">';
      html += '<div class="lgc-stepper"><button data-step="-1" data-key="' + it.key + '"' + (it.quantity <= 1 ? "" : "") + ">\u2013</button><span>" + it.quantity + '</span><button data-step="1" data-key="' + it.key + '">+</button></div>';
      html += '<div class="lgc-price">' + (disc ? '<span class="was">' + money(it.original_line_price) + "</span>" : "") + money(it.final_line_price) + "</div>";
      html += "</div>";
      html += '<button class="lgc-remove" data-remove="' + it.key + '">Remove</button>';
      html += "</div></div>";
    });
    html += "</div>"; // items

    // ladder / upgrade (only when not already at Peak)
    html += renderUpgrade(cart, hasPeak);
    if (SHOW_ACC) html += renderAccessories(cart, offerTitle);
    html += "</div>"; // scroll

    // footer
    html += '<div class="lgc-foot">';
    if (SHOW_DISCOUNT) {
      if (hasPeak) {
        html += '<div class="lgc-dc"><div class="lgc-dc-best">\u2713 Discounts cannot be stacked \u2014 you have the best offer in your cart.</div></div>';
      } else {
        html += '<div class="lgc-dc">';
        if (offerTitle) html += '<div class="lgc-dc-applied"><span>\u2713 \u201C' + offerTitle + '\u201D applied</span><button data-dc-remove>Remove</button></div>';
        html += '<div class="lgc-dc-entry"><input class="lgc-dc-input" placeholder="' + (offerTitle ? "Use a different code" : "Discount code") + '"><button class="lgc-dc-apply" data-dc-apply>Apply</button></div><div class="lgc-dc-err" hidden></div>';
        html += "</div>";
      }
    }
    if (cart.total_discount > 0) html += '<div class="lgc-save"><span>You saved</span><span>\u2013 ' + money(cart.total_discount) + "</span></div>";
    html += '<div class="lgc-subtotal"><span class="lab">Subtotal</span><span class="val">' + money(cart.total_price) + "</span></div>";
    html += '<div class="lgc-tax">Shipping &amp; taxes calculated at checkout.</div>';
    html += '<button class="lgc-checkout" data-checkout>Checkout \u00B7 ' + money(cart.total_price) + "</button>";
    html += "</div>";

    MOUNT.innerHTML = html;
    bind(cart);
  }

  /* build the live ladder model from the cart + config */
  function ladderModel(cart) {
    var pillowItem = cart.items.find(function (it) { return findPillow(it); });
    if (!pillowItem) return null;
    var pillow = findPillow(pillowItem);
    var size = (pillowItem.variant_title || "").split("/")[0].trim() || variantSize(pillow, pillowItem.variant_id) || "Queen";
    var pv = pillow.variants.find(function (v) { return v.id === pillowItem.variant_id; }) || pillow.variants.find(function (v) { return (v.size || "") === size; });
    var unitPillowList = pv ? pv.price : (pillowItem.original_price || pillowItem.price);
    var perUnitDisc = Math.max(0, (pillowItem.original_price || 0) - (pillowItem.final_price || 0));
    var unitPillowNow = unitPillowList - perUnitDisc;

    // matched case (paired metafield → config), size-matched variant
    var caseProd = (CFG.cases || []).find(function (c) { return c.handle === pillow.paired_case_handle; }) || (CFG.cases || [])[0];
    var caseVar = caseProd ? (caseProd.variants.find(function (v) { return v.size === size; }) || caseProd.variants[0]) : null;
    var caseList = caseVar ? caseVar.price : 0;
    var caseDiscountable = !!caseProd; // pillowcases live in Our Pillows
    var caseNow = caseDiscountable ? Math.max(0, caseList - perUnitDisc) : caseList;

    var peakV = peakVariantFor(pillow.title, "cooling", size) || peakVariantFor(pillow.title, null, size);
    var peakPrice = peakV ? peakV.price : 0;
    var peakListValue = 2 * unitPillowList + 2 * caseList; // à-la-carte LIST value of the set

    var pillows = cart.items.filter(function (it) { return findPillow(it); }).reduce(function (s, it) { return s + it.quantity; }, 0);
    var cases = cart.items.filter(function (it) { return findCase(it); }).reduce(function (s, it) { return s + it.quantity; }, 0);
    var relevantSubtotal = cart.items.filter(function (it) { return findPillow(it) || findCase(it); }).reduce(function (s, it) { return s + (it.final_line_price || 0); }, 0);
    var stage = (pillows >= 2 && cases === 0) ? "pair" : (pillows >= 1 && cases >= 1) ? "case" : "pillow";

    return {
      pillow: pillow, size: size, pillowVariantId: pillowItem.variant_id,
      caseVar: caseVar, peakV: peakV, peakPrice: peakPrice, perUnitDisc: perUnitDisc,
      savedVsList: Math.max(0, peakListValue - peakPrice),
      stage: stage, pillowsCount: pillows, casesCount: cases, relevantSubtotal: relevantSubtotal,
      prices: { pillow: unitPillowNow, "case": unitPillowNow + caseNow, pair: 2 * unitPillowNow, peak: peakPrice },
    };
  }

  function ladderHTML(keys, labels, prices, curKey) {
    var cur = keys.indexOf(curKey);
    var h = '<div class="lgc-lad">';
    keys.forEach(function (k, i) {
      h += '<div class="lgc-lad-node' + (i === cur ? " cur" : "") + '">';
      h += '<div class="lgc-lad-dot' + (i < cur ? " done" : i === cur ? " cur" : "") + '">' + (i < cur ? "\u2713" : "") + "</div>";
      h += '<div class="lgc-lad-price">' + money(prices[k]) + "</div>";
      h += '<div class="lgc-lad-lbl">' + labels[k] + "</div></div>";
      if (i < keys.length - 1) h += '<div class="lgc-lad-bar' + (i < cur ? " done" : "") + '"></div>';
    });
    return h + "</div>";
  }
  var LAD_LABELS = { pillow: "Pillow", "case": "+ Case", pair: "2 Pillows", peak: "Peak Set" };

  function heroCard(opts) {
    var h = '<div class="lgc-upg-card hero">';
    if (opts.ribbon) h += '<div class="lgc-upg-ribbon">' + opts.ribbon + "</div>";
    h += '<div class="lgc-upg-cardrow">';
    h += '<div class="lgc-upg-imgs">' + opts.imgs.map(function (s) { return '<div class="lgc-upg-im"><img src="' + s + '" alt=""></div>'; }).join("") + "</div>";
    h += '<div class="lgc-upg-cardmeta"><div class="lgc-upg-h">' + opts.name + "</div><div class=\"lgc-upg-sub\">" + opts.sub + "</div></div>";
    h += '<div class="lgc-upg-cardact"><div class="lgc-upg-plus">' + opts.plus + "</div>";
    h += '<button class="lgc-upg-btn" ' + opts.action + ">" + opts.cta + "</button></div>";
    h += "</div></div>";
    return h;
  }

  function renderUpgrade(cart, hasPeak) {
    var m = ladderModel(cart);
    if (hasPeak) {
      return '<div class="lgc-upg"><div class="lgc-done">\u2705 Best value unlocked \u2014 the Peak Sleep Set</div></div>';
    }
    if (!m) return "";
    var img = m.pillow.image, caseImg = (m.caseVar && (CFG.cases.find(function (c) { return c.variants.indexOf(m.caseVar) !== -1; }) || {}).image) || "";
    // resolve case image robustly
    var caseProd = (CFG.cases || []).find(function (c) { return c.handle === m.pillow.paired_case_handle; }) || (CFG.cases || [])[0];
    caseImg = caseProd ? caseProd.image : "";
    var save = function (c) { return c > 0 ? ' \u00B7 <b>save ' + money(c) + "</b>" : ""; };
    var peakBtn = (m.peakV && m.peakV.available) ? 'data-upgrade-peak="' + m.peakV.id + '"' : "disabled";

    // bulk / 4-pack territory: the Peak Set only holds 2 pillows + 2 cases, so
    // cap it — beyond that, show the 4-pack / add-cases nudges instead.
    if (m.pillowsCount > 2 || m.casesCount > 2) {
      var hb = '<div class="lgc-upg">';
      if (m.pillowsCount >= 4) {
        hb += '<div class="lgc-done">\uD83C\uDF89 You\u2019ve unlocked the 4-Pack' + (FOURPACK > 0 ? ' \u2014 ' + money(FOURPACK) + ' off every pillow' : '') + '</div>';
      } else if (m.pillowsCount === 3 && FOURPACK > 0) {
        hb += '<div class="lgc-upg-title">Buy more, save more</div><div class="lgc-upg-alt"><div class="lgc-upg-alt-meta"><div class="lgc-upg-alt-h">One more unlocks the 4-Pack</div><div class="lgc-upg-alt-sub">Add 1 more pillow &amp; <b>save ' + money(FOURPACK) + ' each</b></div></div><button class="lgc-upg-alt-btn" data-add-multi="' + m.pillowVariantId + '" data-qty="1">Add 1</button></div>';
      }
      if (m.casesCount < m.pillowsCount && m.caseVar) {
        var need = m.pillowsCount - m.casesCount;
        hb += '<div class="lgc-upg-alt"><div class="lgc-upg-alt-meta"><div class="lgc-upg-alt-h">Add cases for your pillows</div><div class="lgc-upg-alt-sub">' + need + ' of your pillows ' + (need === 1 ? 'has' : 'have') + ' no cooling case yet</div></div><button class="lgc-upg-alt-btn" data-add-multi="' + m.caseVar.id + '" data-qty="' + need + '">Add ' + need + '</button></div>';
      }
      return hb + "</div>";
    }

    var html = '<div class="lgc-upg">';

    if (m.stage === "pillow") {
      // they already declined the case on the PDP → push the 2nd pillow (buy more, save more)
      html += '<div class="lgc-upg-title">Buy more, save more</div>';
      html += ladderHTML(m.peakV ? ["pillow", "pair", "peak"] : ["pillow", "pair"], LAD_LABELS, m.prices, "pillow");
      html += heroCard({
        ribbon: "MOST POPULAR" + (m.perUnitDisc > 0 ? " \u00B7 SAVE " + money(m.perUnitDisc) : ""),
        imgs: [img, img], name: "Make it a pair \u2014 add a 2nd " + shortName(m.pillow.title),
        sub: "Two-pillow price <b>" + money(m.prices.pair) + "</b>" + save(m.perUnitDisc),
        plus: "+ " + money(m.prices.pillow), cta: "Add", action: 'data-add="' + m.pillowVariantId + '"',
      });
    } else if (m.stage === "case") {
      html += '<div class="lgc-upg-title">Unlock the best value</div>';
      html += ladderHTML(m.peakV ? ["pillow", "case", "peak"] : ["pillow", "case"], LAD_LABELS, m.prices, "case");
      var addCp = Math.max(0, 2 - m.pillowsCount), addCc = Math.max(0, 2 - m.casesCount);
      var partsC = [];
      if (addCp > 0) partsC.push(addCp + (addCp === 1 ? " pillow" : " pillows"));
      if (addCc > 0) partsC.push(addCc + (addCc === 1 ? " case" : " cases"));
      var addTextC = partsC.length ? "Add " + partsC.join(" + ") : "Make it the bundle";
      var marginalCase = Math.max(0, m.peakPrice - m.relevantSubtotal);
      if (m.peakV) html += heroCard({
        ribbon: "BEST VALUE" + (m.savedVsList > 0 ? " \u00B7 SAVE " + money(m.savedVsList) : ""),
        imgs: [img, caseImg], name: "Upgrade to the Peak Sleep Set",
        sub: addTextC + " \u00B7 <b>" + money(m.peakPrice) + "</b>" + (m.savedVsList > 0 ? " \u00B7 save " + money(m.savedVsList) + " total" : ""),
        plus: "+ " + money(marginalCase), cta: "Upgrade", action: peakBtn,
      });
    } else if (m.stage === "pair") {
      html += '<div class="lgc-upg-title">Complete the set</div>';
      html += ladderHTML(m.peakV ? ["pillow", "pair", "peak"] : ["pillow", "pair"], LAD_LABELS, m.prices, "pair");
      var marginalPair = Math.max(0, m.peakPrice - m.prices.pair);
      if (m.peakV) html += heroCard({
        ribbon: "BEST VALUE" + (m.savedVsList > 0 ? " \u00B7 SAVE " + money(m.savedVsList) : ""),
        imgs: [caseImg, caseImg], name: "Add 2 Cooling Flex cases",
        sub: "Make it the <b>Peak Sleep Set</b>" + (m.savedVsList > 0 ? " \u00B7 save " + money(m.savedVsList) + " total" : ""),
        plus: "+ " + money(marginalPair), cta: "Add", action: peakBtn,
      });
      // Secondary: the 4-pack path for pillow-loyal buyers who declined the case.
      if (FOURPACK > 0) {
        html += '<div class="lgc-upg-alt">';
        html += '<div class="lgc-upg-alt-meta"><div class="lgc-upg-alt-h">Prefer more pillows?</div>';
        html += '<div class="lgc-upg-alt-sub">Add 2 more &amp; <b>save ' + money(FOURPACK) + ' each</b> with a 4-pack</div></div>';
        html += '<button class="lgc-upg-alt-btn" data-add-multi="' + m.pillowVariantId + '" data-qty="2">Add 2</button>';
        html += "</div>";
      }
    }
    html += "</div>";
    return html;
  }

  function shortName(title) {
    return (title || "").split("|")[0].replace(/^the\s+/i, "").trim() || "pillow";
  }

  function renderAccessories(cart, offerTitle) {
    if (!CFG.accessories || !CFG.accessories.length) return "";
    var html = '<div class="lgc-acc"><div class="lgc-acc-head">' + ACC_HEADER + "</div>";
    CFG.accessories.forEach(function (a) {
      var v = (a.variants || [])[0]; if (!v) return;
      var inCart = cart.items.some(function (it) { return it.variant_id === v.id; });
      html += '<div class="lgc-acc-row">';
      html += '<div class="lgc-acc-img"><img src="' + (a.image || "") + '" alt=""></div>';
      html += '<div class="lgc-acc-meta"><div class="lgc-acc-name">' + a.title + "</div>";
      html += '<div class="lgc-acc-price">' + money(v.price) + "</div></div>";
      html += '<button class="lgc-acc-add' + (inCart ? " is-on" : "") + '" data-acc-add="' + v.id + '"' + (v.available ? "" : " disabled") + ">" + (inCart ? "\u2713 Added" : (v.available ? "+ Add" : "Sold out")) + "</button>";
      html += "</div>";
    });
    html += "</div>";
    return html;
  }

  /* ---------- interactions ---------- */
  function refresh() { return getCart().then(render); }

  function bind(cart) {
    MOUNT.querySelectorAll("[data-step]").forEach(function (b) {
      b.addEventListener("click", function () {
        var key = b.getAttribute("data-key"), d = parseInt(b.getAttribute("data-step"), 10);
        var it = cart.items.find(function (x) { return x.key === key; });
        if (!it) return;
        changeLine(key, Math.max(0, it.quantity + d)).then(render);
      });
    });
    MOUNT.querySelectorAll("[data-remove]").forEach(function (b) {
      b.addEventListener("click", function () { changeLine(b.getAttribute("data-remove"), 0).then(render); });
    });
    MOUNT.querySelectorAll("[data-acc-add]").forEach(function (b) {
      b.addEventListener("click", function () {
        var vid = parseInt(b.getAttribute("data-acc-add"), 10);
        var existing = cart.items.find(function (x) { return x.variant_id === vid; });
        if (existing) changeLine(existing.key, 0).then(render);
        else addItems([{ id: vid, quantity: 1 }]).then(refresh);
      });
    });
    // "Make it a pair" / add-one-of-a-variant
    MOUNT.querySelectorAll("[data-add]").forEach(function (b) {
      b.addEventListener("click", function () {
        var vid = parseInt(b.getAttribute("data-add"), 10);
        addItems([{ id: vid, quantity: 1 }]).then(refresh);
      });
    });
    // add N of a variant (4-pack nudge)
    MOUNT.querySelectorAll("[data-add-multi]").forEach(function (b) {
      b.addEventListener("click", function () {
        var vid = parseInt(b.getAttribute("data-add-multi"), 10);
        var q = parseInt(b.getAttribute("data-qty") || "1", 10);
        addItems([{ id: vid, quantity: q }]).then(refresh);
      });
    });
    var up = MOUNT.querySelector("[data-upgrade-peak]");
    if (up) up.addEventListener("click", function () {
      var peakId = parseInt(up.getAttribute("data-upgrade-peak"), 10);
      // remove ALL pillow + case lines, then add the Peak Set variant. We stamp
      // __lgcOp on every call so the PDP add-on won't re-add the companion case.
      window.__lgcOp = Date.now();
      var toZero = cart.items.filter(function (it) { return findPillow(it) || findCase(it); });
      var chain = Promise.resolve();
      toZero.forEach(function (it) { chain = chain.then(function () { window.__lgcOp = Date.now(); return changeLine(it.key, 0); }); });
      chain.then(function () { window.__lgcOp = Date.now(); return addItems([{ id: peakId, quantity: 1 }]); })
        .then(function () { window.__lgcOp = Date.now(); return refresh(); });
    });
    var apply = MOUNT.querySelector("[data-dc-apply]");
    if (apply) apply.addEventListener("click", function () {
      var input = MOUNT.querySelector(".lgc-dc-input"), err = MOUNT.querySelector(".lgc-dc-err");
      var code = (input.value || "").trim();
      if (!code) return;
      if (err) err.hidden = true;
      // Capture the current best discount + code BEFORE applying the new one.
      getCart().then(function (before) {
        var oldDisc = before.total_discount || 0;
        var oldCode = appliedCode(before);
        fetch("/discount/" + encodeURIComponent(code), { credentials: "same-origin" })
          .then(function () { return getCart(); })
          .then(function (after) {
            var newDisc = after.total_discount || 0;
            var applied = appliedDiscountTitle(after);
            // invalid code → restore the previous one (if any) + show error
            if (!applied || (oldCode && code.toUpperCase() !== oldCode.toUpperCase() && newDisc === oldDisc && !appliedCode(after))) {
              var restore = oldCode ? fetch("/discount/" + encodeURIComponent(oldCode), { credentials: "same-origin" }) : Promise.resolve();
              return restore.then(refresh).then(function () { if (err) { err.textContent = "That code isn\u2019t valid."; err.hidden = false; } });
            }
            // new code is WORTH LESS than what's already applied → keep the better one
            if (oldCode && oldCode.toUpperCase() !== code.toUpperCase() && newDisc < oldDisc) {
              return fetch("/discount/" + encodeURIComponent(oldCode), { credentials: "same-origin" })
                .then(refresh)
                .then(function () { if (err) { err.textContent = "No stacking \u2014 you already have the best discount in your cart."; err.hidden = false; } });
            }
            // better or equal → keep it
            return refresh();
          })
          .catch(function () { refresh(); });
      });
    });
    var dcRemove = MOUNT.querySelector("[data-dc-remove]");
    if (dcRemove) dcRemove.addEventListener("click", function () {
      // NOTE: a discount that shows in /cart.js is an AUTOMATIC discount (applied
      // by rule) — Shopify has no AJAX endpoint to remove it, and it re-applies by
      // design. This clears any session code WE stored + re-reads the cart. See
      // INSTALL note: only user-typed CODE discounts are truly removable, and only
      // by navigating. We keep this non-destructive.
      try { sessionStorage.removeItem("lgc_qa_code"); } catch (e) {}
      document.cookie = "discount_code=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/";
      fetch("/cart/update.js", { method: "POST", headers: { "Content-Type": "application/json", "Accept": "application/json" }, body: JSON.stringify({ discount: "" }) })
        .then(function () { return refresh(); })
        .catch(function () { return refresh(); });
    });
    MOUNT.querySelectorAll("[data-lgc-close]").forEach(function (b) { b.addEventListener("click", close); });
    var co = MOUNT.querySelector("[data-checkout]");
    if (co) co.addEventListener("click", function () { window.location.href = "/checkout"; });
  }

  /* ---------- open / close ---------- */
  function open() { STATE.open = true; ROOT.hidden = false; requestAnimationFrame(function () { ROOT.classList.add("is-open"); }); refresh(); }
  function close() { STATE.open = false; ROOT.classList.remove("is-open"); setTimeout(function () { if (!STATE.open) ROOT.hidden = true; }, 320); }
  ROOT.querySelector("[data-lgc-overlay]").addEventListener("click", close);
  document.addEventListener("keydown", function (e) { if (e.key === "Escape" && STATE.open) close(); });

  /* ---------- hooks: open on add-to-cart + cart icon ----------
     DEV: confirm the cart-icon selector for your theme. */
  var RE_ADD = /\/cart\/add(\.js)?(\?|$)/;
  var of = window.fetch;
  if (of && !of.__lgcWrapped) {
    window.fetch = function (input, init) {
      var url = typeof input === "string" ? input : (input && input.url) || "";
      var method = (init && init.method) || (input && input.method) || "GET";
      var isAdd = RE_ADD.test(url) && String(method).toUpperCase() === "POST";
      var p = of.apply(this, arguments);
      if (isAdd) p.then(function (r) { if (r && r.ok) setTimeout(open, 150); }).catch(function () {});
      return p;
    };
    window.fetch.__lgcWrapped = true;
  }
  // cart icon → open our drawer. Listen on WINDOW capture (earliest in the event
  // path) so we beat Booster's own native cart handler.
  function lgcIconHandler(e) {
    if (!e.target || !e.target.closest) return;
    if (e.target.closest("#lagoon-cart")) return;   // never hijack clicks INSIDE our drawer
    var a = e.target.closest('a, button, [role="button"]');
    if (!a) return;
    var href = a.getAttribute("href") || "";
    var isCart = /\/cart(\b|\/|\?|$)/.test(href) ||
      a.matches('[data-cart-icon],[data-cart-trigger],.header__cart,.header__icon--cart,.cart-icon,.js-cart-trigger,.cart-link,.site-header__cart,#cart-icon,.booster-cart,.cart-toggle');
    if (isCart) { e.preventDefault(); e.stopPropagation(); if (e.stopImmediatePropagation) e.stopImmediatePropagation(); open(); }
  }
  window.addEventListener("click", lgcIconHandler, true);
  document.addEventListener("click", lgcIconHandler, true);

  // re-open after a discount-remove navigation
  try {
    if (sessionStorage.getItem("lgc_reopen") === "1" || new URLSearchParams(location.search).get("lgcopen") === "1") {
      sessionStorage.removeItem("lgc_reopen");
      setTimeout(open, 300);
    }
  } catch (e) {}

  // expose for QA: window.LagoonCart.open()
  window.LagoonCart = { open: open, close: close, refresh: refresh };
})();
